import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import * as S from './styles';
import FilterModal from './FilterModal';
import { getWhatsappUserInfo } from 'util/isAdmin';

const ChatListHeader = ( {
	showUnreadOnly,
	searchQuery,
	setSearchQuery,
	activeTab
} ) => {
	const [ isModalOpen, setIsModalOpen ] = useState( false );
	const [ modalPosition, setModalPosition ] = useState( { top: 0, left: 0 } );
	const anchorRef = useRef( null );
	const whatsappUserInfo = getWhatsappUserInfo();
	const showFilterButton = whatsappUserInfo?.profile_type_id === 1 || whatsappUserInfo?.profile_type_id === 2;

	const handleOpenModal = () => {
		if ( anchorRef.current ) {
			const rect = anchorRef.current.getBoundingClientRect();
			setModalPosition( {
				top  : rect.bottom + window.scrollY,
				left : rect.left + window.scrollX
			} );
		}
		setIsModalOpen( ( prev ) => !prev );
	};

	const handleCloseModal = () => {
		setIsModalOpen( false );
	};

	return (
		<S.HeaderContainer>
			<S.HeaderTop>
				<S.Title>
					{activeTab === 'chats' ? 'Conversas' : 'Conversas sem Responsável'}
				</S.Title>
				{showFilterButton && activeTab === 'chats' &&
				<S.FilterButton onClick={handleOpenModal} ref={anchorRef}>
					<FilterListIcon style={{ color: showUnreadOnly ? 'white' : '#aebac1' }} />
				</S.FilterButton>}
				{isModalOpen && <FilterModal onClose={handleCloseModal} position={modalPosition} />}
			</S.HeaderTop>

			<S.SearchContainer>
				<SearchIcon style={{
					position  : 'absolute',
					left      : '12px',
					top       : '50%',
					transform : 'translateY(-50%)',
					color     : '#aebac1'
				}} />
				<S.SearchInput
					type="text"
					placeholder="Pesquisar conversas"
					value={searchQuery}
					onChange={( e ) => setSearchQuery( e.target.value )}
				/>
			</S.SearchContainer>
		</S.HeaderContainer>
	);
};

ChatListHeader.propTypes = {
	showUnreadOnly    : PropTypes.bool.isRequired,
	setShowUnreadOnly : PropTypes.func.isRequired,
	searchQuery       : PropTypes.string.isRequired,
	setSearchQuery    : PropTypes.func.isRequired,
};

export { ChatListHeader };
